import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "../src/shared/styles/globals.css";
import "../src/assets/cemtrik-icons-v1.0/style.css";
import "../src/assets/flags/index.css";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>,
);
